<template>
    <main>
        <section class="carousel-wrapper-new">
            <div class="main-img">
                <picture class="main-img-bg">
                    <source srcset="/brand1.avif" type="image/avif" />
                    <img src="/brand1.svg" alt="hero image" />
                </picture>
                <div class="container1366 section1-container">
                    <div class="section1-left">
                        <h1 class="section1-title">{{ $t("new-home1") }}</h1>
                        <h2 class="section1-subtitle">{{ $t("new-home2") }}</h2>
                        <div class="home-section2-btn-wrapper">
                            <nuxt-link :to="localePath('/register')" class="home-section1-btn1 v-btn__content ga4-reg-btn">{{ $t("lp-collection22") }}</nuxt-link>
                        </div>
                    </div>
                    <div class="section1-right">
                        <div class="home-section1-img">
                            <nuxt-img alt="phone image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/main_home_phone_it.png" />
                            <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/main_home_phone_fr.png" />
                            <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/main_home_phone_de.png" />
                            <nuxt-img alt="phone image" v-else-if="$i18n.locale === 'ru'" format="webp" provider="static" fit="cover" src="/main_home_phone_ru.png" />
                            <nuxt-img alt="phone image" v-else format="webp" provider="static" fit="cover" src="/main_home_phone.png" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="home-section2">
            <div class="container1366 padding200">
                <div class="home-left-50">
                    <div class="home-section2-img">
                        <nuxt-img alt="chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_chart_it.svg" />
                        <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_chart_fr.svg" />
                        <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_chart_de.svg" />
                        <nuxt-img alt="chart image" v-else-if="$i18n.locale === 'ru'" format="webp" provider="static" fit="cover" src="/home_chart_ru.svg" />
                        <nuxt-img alt="chart image" v-else format="webp" provider="static" fit="cover" src="/home_chart.svg" />
                    </div>
                </div>
                <div class="home-right-50">
                    <h2 class="home-section2-title home-section2-title2">{{ $t("new-home5") }}</h2>
                    <div class="home-section2-subtitle">{{ $t("new-home6") }}</div>
                    <div class="home-section2-bullets">
                        <div class="home-section2-bullet">{{ $t("new-home7") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home8") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home9") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home10") }}</div>
                    </div>
                    <div class="home-section2-btn-wrapper">
                        <nuxt-link :prefetch="false" @click.native="goSection('investment-guide')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("new-home4") }}</nuxt-link>
                        <nuxt-link :prefetch="false" :to="localePath('/register')" class="home-section2-btn2 ga4-reg-btn">{{ $t("new-home11") }}</nuxt-link>
                    </div>
                </div>
            </div>
        </section>
        <section class="home-section3" v-if="mobileCheck">
            <div class="container1366 padding200">
                <div class="home-left-50">
                    <div class="home-section3-img">
                        <nuxt-img alt="pie chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_pie_chart_it.svg" />
                        <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_pie_chart_fr.svg" />
                        <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_pie_chart_de.svg" />
                        <nuxt-img alt="pie chart image" v-else format="webp" provider="static" fit="cover" src="/home_pie_chart.svg" />
                    </div>
                </div>
                <div class="home-right-50">
                    <h2 class="home-section2-title">{{ $t("new-home12") }}</h2>
                    <div class="home-section2-subtitle">{{ $t("new-home13") }}</div>
                    <div class="home-section2-bullets">
                        <div class="home-section2-bullet">{{ $t("new-home14") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home15") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home16") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home17") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home18") }}</div>
                    </div>
                    <div class="home-section2-btn-wrapper">
                        <nuxt-link @click.native="goSection('academy-container')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("new-home4") }}</nuxt-link>
                    </div>
                </div>
            </div>
        </section>
        <section class="home-section3" v-else>
            <div class="container1366 padding200">
                <div class="home-left-50">
                    <h2 class="home-section2-title">{{ $t("new-home12") }}</h2>
                    <div class="home-section2-subtitle">{{ $t("new-home13") }}</div>
                    <div class="home-section2-bullets">
                        <div class="home-section2-bullet">{{ $t("new-home14") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home15") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home16") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home17") }}</div>
                        <div class="home-section2-bullet">{{ $t("new-home18") }}</div>
                    </div>
                    <div class="home-section2-btn-wrapper">
                        <nuxt-link @click.native="goSection('academy-container')" :to="localePath('/wine-academy')" class="home-section2-btn1">{{ $t("new-home4") }}</nuxt-link>
                    </div>
                </div>
                <div class="home-right-50">
                    <div class="home-section3-img">
                        <nuxt-img alt="pie chart image" v-if="$i18n.locale === 'it'" format="webp" provider="static" fit="cover" src="/home_pie_chart_it.svg" />
                        <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'fr'" format="webp" provider="static" fit="cover" src="/home_pie_chart_fr.svg" />
                        <nuxt-img alt="pie chart image" v-else-if="$i18n.locale === 'de'" format="webp" provider="static" fit="cover" src="/home_pie_chart_de.svg" />
                        <nuxt-img alt="pie chart image" v-else format="webp" provider="static" fit="cover" src="/home_pie_chart.svg" />
                    </div>
                </div>
            </div>
        </section>
        <section class="invest-brand-message">
            <div class="container1366 padding200 padding80">
                <h2 class="home-title">Invest in wine with Vindome</h2>
                <div class="title-border"></div>
                <div class="invest-vindome-wrapper">
                    <div :class="$i18n.locale.toLowerCase() === 'de' ? 'how-buy-live-market-wrapper-de' : 'how-buy-live-market-wrapper'">
                        <div class="home-left-50">
                            <nuxt-link :to="localePath('/trading-desk')">
                                <div class="section-how-to-buy-img2"></div>
                            </nuxt-link>
                        </div>
                        <div class="home-right-50">
                            <h3><nuxt-link :to="localePath('/trading-desk')">How to invest?</nuxt-link></h3>
                            <div class="content-text">There are two ways to buy wine on the Vindome platform: Collections and Live Market. Both options are simple and secure. The Live market includes both bottled and En Primeur wines.</div>
                            <nuxt-link :to="localePath('/trading-desk')" class="blue-btn how-to-btn">{{ $t("howitworks9") }}</nuxt-link>
                        </div>
                    </div>
                    <div class="how-buy-collection-wrapper" v-if="mobileCheck">
                        <div class="home-left-50">
                            <nuxt-link :to="localePath('/collections')">
                                <div class="section-how-to-buy-img"></div>
                            </nuxt-link>
                        </div>
                        <div class="home-right-50">
                            <h3>How to sell?</h3>
                            <div class="content-text">Selling your wine is easy with Vindome as it is done on the same platform as you bought your wine, just follow a few simple steps.</div>
                            <nuxt-link :to="localePath('/support')" class="blue-btn how-to-btn">Learn more</nuxt-link>
                        </div>
                    </div>
                    <div class="how-buy-collection-wrapper" v-else>
                        <div class="home-left-50">
                            <h3>How to sell?</h3>
                            <div class="content-text">Selling your wine is easy with Vindome as it is done on the same platform as you bought your wine, just follow a few simple steps.</div>
                            <nuxt-link :to="localePath('/support')" class="blue-btn how-to-btn">Learn more</nuxt-link>
                        </div>
                        <div class="home-right-50">
                            <nuxt-link :to="localePath('/collections')">
                                <div class="section-how-to-buy-img"></div>
                            </nuxt-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="guide-brand-message">
            <div class="container1366 padding200 padding80">
                <h2 class="home-title">Get Vindome’s guide to investing in wine</h2>
                <div class="title-border"></div>
                <div class="guide-content" v-if="!nextStep">
                    <div class="guide-reg-wrapper">
                        <div class="guide-subtitle">{{ $t('guide2') }}</div>
                        <div class="mobile-back"></div>
                        <div class="reg-container">
                            <v-flex>
                                <span class="login-label">{{ $t('myprofile1') }} *</span>
                                <v-text-field
                                    id="regFName"
                                    ref="regFName"
                                    v-model="regFName"
                                    class="email-input"
                                    :rules="[rules.required]"
                                    :error="$v.regFName.$error"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">{{ $t('myprofile2') }} *</span>
                                <v-text-field
                                    v-model="regLName"
                                    class="email-input"
                                    :rules="[rules.required]"
                                    :error="$v.regLName.$error"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">Email *</span>
                                <v-text-field
                                    ref="email"
                                    v-model="regEmail"
                                    class="email-input"
                                    :rules="[rules.required, rules.emailValid]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <span class="login-label">Password *</span>
                                <v-text-field
                                    ref="regPassword"
                                    v-model="regPassword"
                                    :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[rules.required, rules.min]"
                                    :type="secureRegPassword ? 'password' : 'text'"
                                    name="input-10-1"
                                    hint="At least 8 characters"
                                    counter
                                    @click:append="secureRegPassword = !secureRegPassword"
                                    v-on:keyup.enter="registration"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-checkbox
                                v-model="checked18"
                                :label="$t('register-confirm18')"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="checkedTerms"
                                class="check-terms"
                            >
                                <div slot="label">
                                    {{ $t('register-terms') }}
                                </div>
                            </v-checkbox>
                            <v-checkbox
                                v-model="checkedNews"
                                :label="$t('register-news')"
                                class="check-terms"
                            ></v-checkbox>
                            <v-flex>
                                <div class="errors-container2" v-if="errorMsg !== ''">
                                    <p>{{ errorMsg }}</p>
                                </div>
                            </v-flex>
                            <v-flex>
                                <v-btn class="submit login-submit" v-on:click="registration">{{ $t('guide3') }}</v-btn>
                            </v-flex>
                        </div>
                    </div>
                </div>
                <div class="guide-content login-inner-container" v-else>
                    <div class="login-success">
                        <h2>Account created successfully</h2>
                        <div class="additional-info">
                            Check your email for an account activation link!
                        </div>
                    </div>

                    <div class="login-success-btn-wrapper">
                        <v-btn class="btn-primary btn-bid-proceed" v-on:click="goToLogin">OK</v-btn>
                        <v-btn class="btn-bid-cancel" v-on:click="resendMail">Resend email</v-btn>
                    </div>
                </div>
            </div>
        </section>
        <section class="home-section6">
            <div class="container1366 padding200">
                <h2>{{ $t("new-home24") }}</h2>
                <div class="title-border"></div>
                <div class="home-section6-item-wrapper">
                    <div class="home-section6-item">
                        <div class="home-section6-img">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 1.42856C18.9333 1.42864 17.9794 2.02787 17.1798 2.94252C16.9782 2.89681 16.7723 2.87373 16.5657 2.8737C16.5518 2.8736 16.5378 2.8736 16.5239 2.8737C15.0009 2.89692 13.7784 4.14255 13.7783 5.67123C13.7787 6.48669 14.1337 7.26137 14.7501 7.79257C14.5408 8.45121 14.3332 9.11248 14.1598 9.84808C13.2038 9.56058 12.2849 9.33345 11.4172 9.1689C9.68524 8.84048 8.15093 8.75761 6.87682 8.97442C5.60271 9.19123 4.53789 9.73642 3.97613 10.7128V10.7158C3.41453 11.6922 3.47548 12.8899 3.92545 14.1057C4.37543 15.3215 5.21173 16.6123 6.36108 17.9534C6.93729 18.6258 7.59282 19.3122 8.31971 20C7.59282 20.6878 6.93729 21.3742 6.36108 22.0465C5.21173 23.3876 4.37543 24.6784 3.92545 25.8942C3.47548 27.1101 3.41453 28.3078 3.97613 29.2842C4.5379 30.2606 5.60271 30.8087 6.87682 31.0256C7.07246 31.0588 7.28624 31.072 7.49392 31.0914C7.89521 32.1966 8.94236 32.9319 10.1144 32.9315C11.5253 32.9306 12.7131 31.872 12.8809 30.466C13.3091 30.3578 13.7141 30.2831 14.1598 30.1489C14.3899 31.1247 14.6547 32.0374 14.9469 32.8746C15.5294 34.5442 16.2245 35.9178 17.0486 36.9168C17.8727 37.9158 18.8766 38.5713 20 38.5714C21.1233 38.5713 22.1272 37.9158 22.9513 36.9168C23.7755 35.9178 24.4705 34.5442 25.0531 32.8746C25.3452 32.0374 25.61 31.1247 25.8401 30.1489C26.7964 30.4366 27.7149 30.6664 28.5828 30.8311C30.315 31.1596 31.8458 31.2423 33.1201 31.0256C34.3945 30.8088 35.462 30.2607 36.0238 29.2842C36.5855 28.3076 36.5246 27.1072 36.0745 25.8913C35.9889 25.6601 35.8775 25.4245 35.7644 25.1881C36.0862 24.7212 36.2588 24.1671 36.2593 23.5994C36.259 22.0545 35.0112 20.8022 33.4719 20.8018C33.458 20.8017 33.4441 20.8017 33.4302 20.8018C33.1433 20.8058 32.8587 20.8543 32.5865 20.9455C32.2809 20.6283 32.0144 20.316 31.6772 19.997C32.4036 19.3099 33.0599 18.6285 33.6359 17.9564C34.7855 16.6151 35.6244 15.3217 36.0745 14.1057C36.5246 12.8897 36.5855 11.6923 36.0238 10.7158V10.7128C35.462 9.73629 34.3945 9.19118 33.1201 8.97442C31.8458 8.75766 30.315 8.84032 28.5828 9.1689C27.7149 9.33353 26.7964 9.56333 25.8401 9.85108C25.61 8.87526 25.3452 7.96277 25.0531 7.12535C24.4705 5.45549 23.7755 4.07938 22.9513 3.08015C22.1271 2.08092 21.1235 1.42865 20 1.42856ZM20 2.78992C20.6003 2.78997 21.2384 3.13917 21.9079 3.95083C22.5774 4.76248 23.2271 6.00618 23.7741 7.57415C24.0614 8.39757 24.3194 9.31801 24.5463 10.3029C23.0843 10.806 21.5703 11.4059 20 12.1609C18.4304 11.4064 16.9179 10.8026 15.4567 10.2999C15.6114 9.62936 15.7844 9.00349 15.9664 8.40294C16.1632 8.44655 16.3641 8.46862 16.5657 8.46877C18.105 8.46843 19.3527 7.21613 19.3531 5.67123C19.3518 4.87899 19.0159 4.12441 18.4289 3.59478C18.9755 3.04901 19.5017 2.78996 20 2.78992ZM7.94706 10.2311C8.85343 10.187 9.94409 10.275 11.1638 10.5063C12.0177 10.6683 12.9401 10.9085 13.9035 11.2035C13.6073 12.7242 13.3719 14.34 13.2387 16.0804C11.8017 17.068 10.5255 18.083 9.36014 19.1024C8.62328 18.4123 7.95672 17.7296 7.38958 17.0678C6.31038 15.8085 5.56093 14.6205 5.19544 13.633C4.82994 12.6454 4.84764 11.9167 5.14774 11.395C5.44792 10.8732 6.06849 10.4939 7.10339 10.3178C7.36211 10.2738 7.64494 10.2457 7.94706 10.2311ZM31.084 10.2311C31.7664 10.2005 32.376 10.2298 32.8936 10.3178C33.9287 10.4939 34.549 10.8732 34.8492 11.395C35.1494 11.9168 35.1672 12.6453 34.8015 13.633C34.4359 14.6207 33.6869 15.8084 32.6074 17.0678C32.0409 17.7288 31.3754 18.41 30.6398 19.0994C29.475 18.0804 28.1975 17.0677 26.7613 16.0804C26.6276 14.3401 26.3931 12.7241 26.0965 11.2035C27.0589 10.9086 27.9799 10.6682 28.8332 10.5063C29.6465 10.3521 30.4016 10.2616 31.084 10.2311ZM15.2003 11.6553C16.2504 12.0233 17.332 12.4598 18.4527 12.9658C17.8156 13.3 17.181 13.6139 16.5388 13.986C15.8966 14.3582 15.3095 14.7541 14.7024 15.141C14.8263 13.9128 14.9926 12.7529 15.2003 11.6553ZM24.7997 11.6553C25.0068 12.752 25.174 13.9109 25.2975 15.138C24.6898 14.7507 24.1012 14.3556 23.4581 13.983C22.817 13.6116 22.1833 13.2994 21.5472 12.9658C22.6677 12.4597 23.7498 12.0235 24.7997 11.6553ZM20 13.6809C20.9193 14.1378 21.8479 14.621 22.7814 15.1619C23.7154 15.703 24.5984 16.2666 25.4525 16.8374C25.5179 17.8665 25.5629 18.9163 25.5629 20C25.5628 21.0835 25.5179 22.1335 25.4525 23.1625C24.5984 23.7333 23.7154 24.297 22.7814 24.8381C21.8479 25.379 20.9193 25.8622 20 26.3191C19.0795 25.8615 18.1503 25.3768 17.2155 24.8351C16.2818 24.294 15.3986 23.7301 14.5444 23.1596C14.4789 22.1314 14.4341 21.0825 14.4341 20C14.4341 18.9173 14.4789 17.8686 14.5444 16.8404C15.3986 16.2698 16.2818 15.706 17.2155 15.1649C18.1503 14.6232 19.0795 14.1385 20 13.6809ZM19.8688 16.0005C17.7024 16.0005 15.9314 17.7778 15.9314 19.9521C15.9314 22.1264 17.7024 23.9038 19.8688 23.9038C22.0352 23.9038 23.8061 22.1264 23.8061 19.9521C23.8061 17.7778 22.0352 16.0005 19.8688 16.0005ZM13.1582 17.8248C13.128 18.5464 13.0806 19.255 13.0807 20C13.0807 20.7449 13.1279 21.4536 13.1582 22.1752C12.1597 21.4534 11.2414 20.7294 10.3976 20C11.2414 19.2706 12.1597 18.5466 13.1582 17.8248H13.1582ZM26.8418 17.8248C27.8392 18.5464 28.7564 19.2708 29.5994 20C28.7564 20.7291 27.8392 21.4536 26.8418 22.1752C26.8721 21.4536 26.9193 20.7449 26.9193 20C26.9193 19.255 26.872 18.5464 26.8418 17.8248ZM9.36014 20.8976C10.5255 21.917 11.8017 22.932 13.2387 23.9195C13.3723 25.6599 13.6069 27.2758 13.9035 28.7965C13.4981 28.9206 13.1057 29.0286 12.7169 29.1316C12.3033 28.0503 11.2685 27.3365 10.1144 27.3364C10.0995 27.3363 10.0846 27.3363 10.0697 27.3364C8.7098 27.3573 7.56343 28.36 7.35679 29.7091C7.275 29.6985 7.18113 29.6954 7.10339 29.6821C6.06849 29.506 5.44792 29.1267 5.14774 28.605C4.84764 28.0832 4.82994 27.3545 5.19544 26.367C5.56093 25.3794 6.31038 24.1914 7.38958 22.9322C7.95672 22.2704 8.62328 21.5877 9.36014 20.8976ZM30.6368 20.8976C30.9189 21.1619 31.1818 21.4232 31.4417 21.6845C30.9559 22.2029 30.6851 22.8877 30.6845 23.5994C30.6849 25.1443 31.9326 26.3966 33.4719 26.3969C33.8933 26.3966 34.3092 26.3005 34.6882 26.1157C34.723 26.1984 34.7718 26.2868 34.8015 26.367C35.1672 27.3547 35.1494 28.0832 34.8492 28.605C34.549 29.1268 33.9287 29.5061 32.8936 29.6821C31.8585 29.8582 30.4597 29.8022 28.8332 29.4936C27.9799 29.3318 27.0589 29.0914 26.0965 28.7965C26.3932 27.2749 26.6276 25.6581 26.7613 23.9165C28.1968 22.9302 29.4725 21.9156 30.6368 20.8976H30.6368ZM14.7024 24.859C15.3095 25.2458 15.8966 25.6418 16.5388 26.0139C17.181 26.3861 17.8156 26.7 18.4527 27.0342C17.332 27.5401 16.2504 27.9766 15.2003 28.3447C14.9926 27.247 14.8263 26.0872 14.7024 24.859ZM25.2975 24.859C25.174 26.0873 25.007 27.247 24.7997 28.3447C23.749 27.9762 22.6656 27.5408 21.5442 27.0342C22.1815 26.6999 22.8158 26.3861 23.4581 26.0139C24.1012 25.6414 24.6898 25.2462 25.2975 24.859ZM19.994 27.8361C21.5665 28.5924 23.0823 29.1934 24.5463 29.6971C24.3194 30.682 24.0614 31.6026 23.7741 32.4258C23.2271 33.9935 22.5773 35.2377 21.9079 36.0491C21.2385 36.8606 20.6003 37.21 20 37.21C19.3997 37.21 18.7614 36.8606 18.092 36.0491C17.4226 35.2377 16.7728 33.9935 16.2258 32.4258C15.9385 31.6026 15.6808 30.682 15.4537 29.6971C16.9141 29.1943 18.4253 28.5904 19.994 27.8361Z" fill="#907D4C"/>
                            </svg>
                        </div>
                        <div class="home-section6-title">{{ $t("new-home25") }}</div>
                        <div class="home-section6-subtitle">{{ $t("new-home26") }}</div>
                    </div>
                    <div class="home-section6-item">
                        <div class="home-section6-img">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.0107 3.66182C16.5098 3.39587 15.8991 3.74877 15.8991 4.30416V6.10586C9.62498 7.72132 5 13.2851 5 19.9003C5 26.0262 8.96544 31.2477 14.5301 33.2705L15.319 31.2142C10.6072 29.5014 7.25498 25.0805 7.25498 19.9003C7.25498 14.508 10.8867 9.94144 15.8991 8.3918V10.6193C15.8991 11.1746 16.5098 11.5275 17.0107 11.2616L22.9576 8.10405C23.4799 7.82673 23.4799 7.09668 22.9576 6.81936L17.0107 3.66182Z" fill="#907D4C"/>
                                <path d="M22.9893 36.3382C23.4902 36.6042 24.1009 36.2513 24.1009 35.6959V33.8942C30.375 32.2787 35 26.715 35 20.0997C35 13.9739 31.0346 8.75234 25.4699 6.7295L24.681 8.78584C29.3928 10.4987 32.745 14.9195 32.745 20.0997C32.745 25.492 29.1133 30.0586 24.1009 31.6082V29.3808C24.1009 28.8254 23.4902 28.4725 22.9893 28.7384L17.0424 31.896C16.5201 32.1733 16.5201 32.9033 17.0424 33.1807L22.9893 36.3382Z" fill="#907D4C"/>
                                <path d="M21.3714 27.381V25.5619C23.0286 25.2476 24.3333 24.2953 24.3429 22.5524C24.3429 20.1524 22.2857 19.3238 20.3619 18.8286C18.4381 18.3333 17.819 17.8095 17.819 17.0095C17.819 16.0953 18.6762 15.4476 20.1048 15.4476C21.6095 15.4476 22.1714 16.1714 22.219 17.2286H24.0857C24.0286 15.7714 23.1429 14.4286 21.3714 14V12.1429H18.8286V13.981C17.1905 14.3333 15.8667 15.4 15.8667 17.0381C15.8667 18.9905 17.4857 19.9619 19.8476 20.5333C21.9714 21.0381 22.3905 21.781 22.3905 22.5714C22.3905 23.1524 21.9714 24.0857 20.1048 24.0857C18.3619 24.0857 17.6762 23.3048 17.581 22.3048H15.7143C15.819 24.1524 17.2 25.2 18.8286 25.5429V27.381H21.3714Z" fill="#907D4C"/>
                            </svg>
                        </div>
                        <div class="home-section6-title">{{ $t("new-home27") }}</div>
                        <div class="home-section6-subtitle">{{ $t("new-home28") }}</div>
                    </div>
                    <div class="home-section6-item">
                        <div class="home-section6-img">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M30.9244 1.44544L14.1177 1.42856C12.2689 1.42856 10.7563 2.94804 10.7563 4.80518V9.87012H14.1177V5.32466H30.9244V34.6753H14.1177V30.1299H10.7563V35.1948C10.7563 37.0519 12.2689 38.5714 14.1177 38.5714H30.9244C32.7731 38.5714 34.2857 37.0519 34.2857 35.1948V4.80518C34.2857 2.94804 32.7731 1.44544 30.9244 1.44544ZM17.479 25.0649H20.8403V13.2467H9.07564V16.6234H15.1093L5.71429 26.061L8.08404 28.4415L17.479 19.0039V25.0649Z" fill="#907D4C"/>
                            </svg>
                        </div>
                        <div class="home-section6-title">{{ $t("new-home29") }}</div>
                        <div class="home-section6-subtitle">{{ $t("new-home30") }}</div>
                    </div>
                </div>
                <div class="home-section6-item-wrapper">
                    <div class="home-section6-item">
                        <div class="home-section6-img">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.1429 3.57143H7.85714V6.42857H12.1429V3.57143Z" fill="#907D4C"/>
                                <path d="M12.1429 7.85714H7.85714V12.2654C7.85714 12.6443 7.70663 13.0077 7.43872 13.2756L6.55112 14.1632C6.0153 14.699 5.71428 15.4257 5.71428 16.1835V35C5.71428 35.789 6.35387 36.4286 7.14285 36.4286H12.8571C13.6461 36.4286 14.2857 35.789 14.2857 35V16.1835C14.2857 15.4257 13.9847 14.699 13.4489 14.1632L12.5613 13.2756C12.2934 13.0077 12.1429 12.6443 12.1429 12.2654V7.85714Z" fill="#907D4C"/>
                                <path d="M22.1429 3.57143H17.8571V6.42857H22.1429V3.57143Z" fill="#907D4C"/>
                                <path d="M22.1429 7.85714H17.8571V12.2654C17.8571 12.6443 17.7066 13.0077 17.4387 13.2756L16.5511 14.1632C16.0153 14.699 15.7143 15.4257 15.7143 16.1835V35C15.7143 35.789 16.3539 36.4286 17.1429 36.4286H22.8571C23.6461 36.4286 24.2857 35.789 24.2857 35V16.1835C24.2857 15.4257 23.9847 14.699 23.4489 14.1632L22.5613 13.2756C22.2934 13.0077 22.1429 12.6443 22.1429 12.2654V7.85714Z" fill="#907D4C"/>
                                <path d="M32.1429 3.57143H27.8571V6.42857H32.1429V3.57143Z" fill="#907D4C"/>
                                <path d="M32.1429 7.85714H27.8571V12.2654C27.8571 12.6443 27.7066 13.0077 27.4387 13.2756L26.5511 14.1632C26.0153 14.699 25.7143 15.4257 25.7143 16.1835V35C25.7143 35.789 26.3539 36.4286 27.1429 36.4286H32.8571C33.6461 36.4286 34.2857 35.789 34.2857 35V16.1835C34.2857 15.4257 33.9847 14.699 33.4489 14.1632L32.5613 13.2756C32.2934 13.0077 32.1429 12.6443 32.1429 12.2654V7.85714Z" fill="#907D4C"/>
                            </svg>
                        </div>
                        <div class="home-section6-title">{{ $t("new-home31") }}</div>
                        <div class="home-section6-subtitle">{{ $t("new-home32") }}</div>
                    </div>
                    <div class="home-section6-item">
                        <div class="home-section6-img">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M33.1429 3.57143H6.85714C5.05 3.57143 3.57143 5.05 3.57143 6.85714V33.1429C3.57143 34.95 5.05 36.4286 6.85714 36.4286H33.1429C34.95 36.4286 36.4286 34.95 36.4286 33.1429V6.85714C36.4286 5.05 34.95 3.57143 33.1429 3.57143ZM33.1429 33.1429H6.85714V6.85714H33.1429V33.1429ZM29.8571 10.1429H21.6429C19.8357 10.1429 18.3571 11.6214 18.3571 13.4286V17.1743C17.3714 17.7493 16.7143 18.7843 16.7143 20C16.7143 21.8071 18.1929 23.2857 20 23.2857C21.8071 23.2857 23.2857 21.8071 23.2857 20C23.2857 18.7843 22.6286 17.7329 21.6429 17.1743V13.4286H26.5714V26.5714H13.4286V13.4286H16.7143V10.1429H10.1429V29.8571H29.8571V10.1429Z" fill="#907D4C"/>
                            </svg>
                        </div>
                        <div class="home-section6-title">{{ $t("new-home33") }}</div>
                        <div class="home-section6-subtitle">{{ $t("new-home34") }}</div>
                    </div>
                    <div class="home-section6-item">
                        <div class="home-section6-img">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.4106 3.57153C12.753 3.83319 6.85742 8.01678 4.56476 14.3306C2.19711 20.8506 4.15423 28.1617 9.4571 32.6216C14.5926 36.9409 21.786 37.6104 27.6825 34.4996L19.4106 20.1469V3.57153ZM21.3338 3.61241V18.6852H36.3716C35.73 10.6214 29.3789 4.25574 21.3338 3.61241ZM23.5192 6.20107C28.5688 7.47877 32.5143 11.4334 33.7889 16.4947H23.5192V6.20107ZM21.8935 20.6104L29.3308 33.5153C33.605 30.5666 36.226 25.8078 36.4287 20.6104H21.8935Z" fill="#907D4C"/>
                            </svg>
                        </div>
                        <div class="home-section6-title">{{ $t("new-home35") }}</div>
                        <div class="home-section6-subtitle">{{ $t("new-home36") }}</div>
                    </div>
                </div>
            </div>
        </section>


        <section class="lp-register">
            <div class="container1366 padding200 padding80">
                <div class="marginBottom16">Register now and get free storage and insurance when you purchase your first Collection</div>
                <nuxt-link :to="localePath('/register')" class="home-section1-btn1 v-btn__content ga4-reg-btn">Register Now</nuxt-link>
            </div>
        </section>
    </main>
</template>

<script>
import {required, email, minLength} from 'vuelidate/lib/validators';
import {mapActions, mapGetters} from "vuex";
    import {GCommon} from "../store/getters";
    import 'vueperslides/dist/vueperslides.css'
import {AAuth} from "@/store/actions";

    export default {
        name: 'home',
        validations: {
            regFName: {
                required
            },
            regLName: {
                required
            },
            regEmail: {
                required,
                email
            },
            regPassword: {
                required,
                minLength: minLength(8)
            }
        },
        head: {
            title: 'En Primeur Purchase | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'home page-lp-collections'
            }
        },
        data() {
            return {
                show: false,
                showContactUs: false,
                appStore: false,
                googlePlay: false,
                collectionItems: [],
                topCollectionItems: [],
                restCollectionsItems: [],
                topEnCollectionItems: [],
                moreCollectionsItems: [],
                popularWines: [],
                popularEnWines: [],
                selectedTab: 3,
                successMessage: false,
                successMessageEn: false,
                errorMsg: '',
                errorMsg2: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || 'Invalid email'
                },
                regEmail: '',
                regPassword: '',
                regFName: '',
                regLName: '',
                countryId: 224,
                isLoading: false,
                checkedTerms: false,
                checked18: false,
                checkedNews: true,
                secureRegPassword: true,
                nextStep: false
            }
        },
        computed: {
            ...mapGetters({
                mobileCheck: GCommon.GET_MOBILE_VERSION
            })
        },
        methods: {
            goSection(val) {
                this.$nuxt.$emit("goToSection", val);
            },
            isEmailValid(email) {
                return this.reg.test(email)
            },
            goToLogin() {
                this.$router.push(this.localePath({path: '/login'}));
            },
            resendMail() {
                this.sendMail(this.regEmail)
            },
            registration() {
                this.$v.regFName.$touch();
                this.$v.regLName.$touch();
                if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                    if (this.checkedTerms && this.checked18) {
                        this.isLoading = true;
                        let payload = {
                            email: this.regEmail,
                            password: this.regPassword,
                            confirmPassword: this.regPassword,
                            firstname: this.regFName,
                            lastname: this.regLName,
                            countryId: this.countryId,
                            phoneNumber: '',
                            name: '',
                            enabledNotification: this.enabledNotification === true ? 1 : 0,
                            newsletter: this.checkedNews
                        };
                        this.signup(payload).then(res => {
                            if (res.reasonPhrase === "Created") {
                                this.nextStep = true;
                            }

                            this.$gtm.push({ event: "registration" });
                            window.fbq('track', 'CompleteRegistration');
                            window.uetq = window.uetq || [];
                            window.uetq.push("event", "signup", {});
                            this.$gtm.push({
                                'event': 'UETRegistration',
                                'ecomm_pagetype': 'conversion'
                            });
                        }).catch(err => {
                            this.isLoading = false;
                            if (err.data.errors) {
                                if (err.data.errors.Email.length) {
                                    err.data.errors.Email.forEach(err => {
                                        this.errorMsg = err;
                                    })
                                } else if (err.data.errors.GeneralError.length) {
                                    err.data.errors.GeneralError.forEach(err => {
                                        this.errorMsg = err;
                                    })
                                } else {
                                    this.errorMsg = 'Unexpected behavior. Please check your internet connection or try again later.';
                                }
                            }
                        })
                    } else {
                        this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                    }
                } else {
                    this.errorMsg = 'Please fill the above information.';
                }

            },
            ...mapActions({
                signup: AAuth.REG_USER,
                sendMail: AAuth.SEND_MAIL
            })
        },
        created (){

        }
    };
</script>

<style scoped>
.home-section6 {
    min-height: 629px;
    padding: 80px 0;
}
.home-section6-item-wrapper {
    vertical-align: top;
}
.home-section6-item {
    display: inline-block;
    width: calc((100% - 56px) / 3);
    padding-left: 53px;
    position: relative;
    vertical-align: top;
    margin-bottom: 42px;
}
.home-section6-item-wrapper > .home-section6-item:nth-child(1),
.home-section6-item-wrapper > .home-section6-item:nth-child(2) {
    margin-right: 24px;
}
.home-section6-title {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #002840;
    margin-bottom: 8px;
}
.home-section6-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
}
.home-section6-img {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    left: 0;
}
.guide-content {
    height: 100%;
    padding: 24px;
    background: url("../assets/landing/lp-guide.svg") no-repeat right bottom;
    background-size: 438px 480px;
}
.guide-content.login-inner-container {
    background: #f4f4f4 url("../assets/landing/lp-guide.svg") no-repeat right bottom;
    background-size: 438px 480px;
}
.guide-reg-wrapper, .login-success, .login-success-btn-wrapper {
    width: calc(100% - 455px);
}
.guide-subtitle {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    color: #002840;
    margin-bottom: 21px;
}
.mobile-back {
    display: none;
}
.invest-brand-message, .home-section6 {
    background: #F7F7F7;
}
.theme--light.v-btn.v-btn--has-bg.login-submit {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    gap: 8px;
    width: 100%;
    height: 40px;
    background: #004F7F;
    border-radius: 8px;
    margin-top: 24px;
    text-transform: none;
}
.errors-container2 {
    height: auto;
    width: 100%;
    background: transparent;
    margin: 0;
}

.errors-container2 p {
    color: #D75353;
    line-height: 12px;
    font-size: var(--fs-small);
    padding-left: 0;
    margin-bottom: 0;
    padding-top: 5;
}
.login-success {
    background: url("../assets/how/ok.gif") no-repeat center top;
    background-size: 250px;
    padding-top: 280px;
}
.login-inner-container {
    height: 100%;
    padding: 24px;
}
.login-success-btn-wrapper {
    text-align: center;
}
.additional-info {
    text-align: center;
    margin: 32px auto;
}
.theme--light.v-btn.v-btn--has-bg.btn-bid-proceed {
    background: #004F7F;
    border-color: #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    margin-right: 16px;
}
.theme--light.v-btn.v-btn--has-bg.btn-bid-cancel {
    border: 1px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #004F7F;
}
.marginBottom16 {
    margin-bottom: 16px;
}
.small-subtitle-text {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    margin: 16px auto 0;
    color: #FFFFFF;
}
.home-section1-btn1 {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    display: inline-block;
    color: #004F7F;
}
.home-section2 {
    height: 430px;
    padding: 52px 0 45px;
}
.home-section2-img, .home-section3-img {
    height: 100%;
    width: 100%;
}
.home-section2-img img,
.home-section3-img img {
    background-size: contain;
    height: 100%;
    width: 100%;
}
.home-section2-title {
    color: #002840;
    font-family: Montserrat,Arial,Helvetica,sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 8px;
    margin-top: 39px;
    text-align: left;
}
.home-section2-subtitle {
    align-items: center;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 24px;
}
.home-section2-bullet,
.home-section2-subtitle {
    color: #002840;
    font-family: Montserrat,Arial,Helvetica,sans-serif;
    font-style: normal;
}
.home-section2-bullet {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #002840;
    padding-left: 17px;
    background: url("../assets/home/bullet-point.svg") no-repeat left center;
}
.home-section2-bullets {
    margin-bottom: 24px;
}
.home-section2-btn1 {
    padding: 8px 16px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    color: #ffffff;
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
}
.home-section2-btn2 {
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #004F7F;
    border: 2px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    height: 36px;
    margin-left: 12px;
}
.home-section2-btn1.btn-white {
    background: #ffffff;
    color: #004F7F;
}
.home-section2-btn1.btn-white:hover {
    cursor: pointer;
}
.home-section2-btn2.border-white {
    border-color: white;
    color: white;
}
.home-section3 {
    padding-bottom: 80px;
}
    .how-enprimeur-item {
        display: inline-block;
        width: calc((100% - 84px) / 4);
        vertical-align: top;
        padding-top: 72px;
        text-align: center;
    }
    .how-enprimeur-item1 {
        background: url("../assets/landing/en1.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item2 {
        background: url("../assets/landing/en2.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item3 {
        background: url("../assets/landing/en3.png") no-repeat center top;
        margin-right: 24px;
    }
    .how-enprimeur-item4 {
        background: url("../assets/landing/en4.png") no-repeat center top;
    }
    .how-enprimeur-item-title {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #002840;
    }
    .how-enprimeur-item-text {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: #002840;
        margin-top: 8px;
    }
    .how-enprimeur-wrapper {
        padding-bottom: 60px;
        background: url("../assets/landing/timeline.png") no-repeat center bottom;
    }
    #how-enprimeur {
        background: #F7F7F7;
    }
    .iframe-container2 iframe {
        border: 0;
        width: 100%;
        height: 83px;
        margin-top: 16px;
    }
    .lp-register {
        background: linear-gradient(88.98deg, #003758 0%, #004B79 52.08%, #00629D 100%);
        color: white;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
    }


    .home ul {
        padding-left: 0;
    }

    .container {
        position: relative;
        max-width: 1170px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .padding200 {
        padding: 0 200px;
    }
    .padding80 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .title-border {
        width: 64px;
        height: 4px;
        background: #ECD9A7;
        margin: 24px auto 40px;
    }

    .hidden {
        display: none;
    }

    /* reset */

    body, div, dl, dt, dd, ul, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, input, textarea, p, blockquote, th, td {
        margin: 0;
        padding: 0;
    }

    table {
        border-spacing: 0;
        border-collapse: collapse;
    }

    fieldset, img, abbr {
        border: 0;
    }

    address, caption, cite, code, dfn, em, strong, th, var {
        font-weight: normal;
        font-style: normal;
    }

    ul li {
        list-style: none;
    }

    caption, th {
        text-align: left;
    }

    button {
        border: none;
        background: none;
    }

    button:hover {
        cursor: pointer;
    }

    a {
        text-decoration: none;
    }

    /* slogan section */
    .carousel-wrapper-new {
        height: 542px;
        position: relative;
        top: 79px;
        margin-bottom: 80px;
    }
    .section-how-to-buy {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .how-buy-live-market-wrapper {
        height: 354px;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    .how-buy-live-market-wrapper-de {
        height: 354px;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    h2 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        text-align: center;
    }
    .section-how-to-buy-img {
        background: url("../assets/how/create-offer.png") no-repeat center;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .section-how-to-buy-img2 {
        background: url("../assets/home/home_collections_en.png") no-repeat center;
        background-size: contain;
        width: 100%;
        height: 100%;
    }
    .home-left-50,
    .home-right-50 {
        display: inline-block;
        width: calc((100% - 24px) / 2);
        height: 100%;
        vertical-align: top;
    }

    .home-left-50 {
        margin-right: 20px;
    }
    .blue-btn {
        padding: 8px 16px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        color: #ffffff;
        display: inline-block;
        vertical-align: top;
        font-family: "Montserrat", Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        text-decoration: none;
        margin-top: 24px;
    }
    .blue-btn:hover {
        cursor: pointer;
    }
    .content-text {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #002840;
        padding-top: 30px;
    }
    .main-img {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
        background-size: cover;
    }
    .main-img-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
.section1-left,
.section1-right {
    display: inline-block;
    vertical-align: top;
    height: 100%;
}
.section1-right {
    width: 178px;
}
.section1-left {
    margin-right: 24px;
    width: calc(100% - 208px);
}
.section1-title {
    margin-top: 59px;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 44px;
    color: #FFFFFF;
    margin-bottom: 16px;
    text-align: left;
}
.section1-subtitle {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 27px;
    color: #FFFFFF;
    margin-bottom: 32px;
    text-align: left;
}
.home-section1-img {
    width: 100%;
    height: 100%;
    position: relative;
    text-align: right;
    background-size: contain;
    background-position: right center;
}
.home-section1-img img {
    background-size: contain;
    width: 100%;
    height: 100%;
    max-height: 360px;
    max-width: 180px;
}
    .section1-container {
        height: 100%;
        padding: 91px 200px;
    }
    .main-title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 120px auto 0;
        text-align: center;
        max-width: 966px;
    }
    .main-title h1 {
        color: #ffffff;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 36px;
        line-height: 44px;
        margin-bottom: 0;
    }
    .main-subtitle {
        margin-top: 16px;
        margin-bottom: 32px;
        text-align: center;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 27px;
        color: #ffffff;
    }
    .iframe-container {
        width: 100%;
        left: 0;
        right: 0;
        margin: 0 auto;
    }
    .iframe-container iframe {
        border: 0;
        width: 100%;
        height: 132px;
        border-radius: 32px;
    }

    /* START Top Collections */
    .home-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        margin-bottom: 24px;
        position: relative;
        text-align: center;
    }

    .show-all-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 120px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        display: block;
        color: #FFFFFF;
        text-align: center;
        margin: 0 auto;
    }

    .home-collections-container {
        max-width: 1214px;
        margin: 0 auto;
    }

    /* END Top Collections */

    .home-title-wine {
        text-align: center;
        font-weight: 400;
        font-size: 40px;
        line-height: 47px;
        margin: 24px auto 40px;
    }
    .home-title-live {
        margin-top: 50px;
    }

    .browse-market-btn {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 321px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #FFFFFF;
        display: block;
        text-align: center;
        margin: 46px auto 0;
    }
    .browse-market-btn-de {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        padding: 8px 16px;
        width: 321px;
        height: 56px;
        background: #004F7F;
        border-radius: 8px;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        color: #FFFFFF;
        display: block;
        text-align: center;
        margin: 46px auto 0;
    }
    #latest-offers {
        background-color: #F7F7F7;
    }
    .latest-offers-wrapper {
        margin-top: 16px;
    }
    .how-buy-collection-wrapper {
        height: 227px;
    }
    .how-buy-collection-wrapper h3 {
        padding-top: 40px;
    }

    .invest-brand-message h3, .invest-brand-message h3 a {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #002840;
    }

.invest-brand-message .content-text {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #002840;
    padding-top: 8px;
}
.how-buy-live-market-wrapper h3 {
    padding-top: 90px;
}

    @media(max-width: 767px) {
        .guide-content.login-inner-container {
            background: #f4f4f4;
        }
        .login-success, .login-success-btn-wrapper {
            width: 100%;
        }
        .carousel-wrapper-new {
            height: 400px;
        }
        .section1-container {
            padding: 16px;
        }
        .section1-title {
            margin-top: 20px;
            font-size: 17px;
            line-height: 24px;
            margin-bottom: 10px;
        }
        .section1-subtitle {
            font-size: 14px;
            line-height: 17px;
        }
        .home-section1-btn1,
        .home-section1-btn2 {
            display: block;
            text-align: center;
        }
        .home-section1-btn1 {
            margin-bottom: 12px;
        }
        .home-section1-btn2 {
            margin-left: 0;
        }
        .home-section2, .home-section3 {
            height: auto;
            padding: 16px 0;
        }
        .home-section2 .container1366, .home-section3 .container1366 {
            height: 100%;
        }
        .home-left-50 {
            height: 200px;
            margin-right: 0;
        }
        .home-left-50, .home-right-50 {
            display: block;
            width: 100%;
        }
        .home-section3 .home-left-50 {
            height: auto;
        }
        .how-buy-live-market-wrapper,
        .how-buy-live-market-wrapper-de,
        .how-buy-collection-wrapper {
            height: auto;
        }
        .guide-content {
            background: #ffffff;
        }
        .guide-reg-wrapper,
        .theme--light.v-btn.v-btn--has-bg.login-submit {
            width: 100%;
        }
        .mobile-back {
            display: block;
            height: 177px;
            margin-top: 32px;
            margin-bottom: 32px;
            width: 100%;
            background: url("../assets/how/mobile_back.png") no-repeat right bottom;
        }
        .guide-title {
            width: calc(100% - 30px);
        }
        .home-section6 {
            padding: 32px 0 0;
        }
        .home-section6-item {
            display: block;
            width: 100%;
            padding-left: 53px;
            margin-bottom: 42px;
        }
        .home-section6-item-wrapper > .home-section6-item:nth-child(1),
        .home-section6-item-wrapper > .home-section6-item:nth-child(2) {
            margin-right: 0;
        }
        .home-left-50, .home-right-50 {
            display: block;
            width: 100%;
        }
        .section-how-to-buy-img2 {
            height: 200px;
        }
        .main-title {
            font-size: 22px;
            line-height: 36px;
            margin: 70px auto;
        }
        .home-title {
            font-size: 17px;
            line-height: 17px;
            font-weight: 700;
        }
        .collections-h1 {
            font-size: 22px;
        }
        .show-all-btn {
            display: none;
        }
        .browse-market-btn, .browse-market-btn-de {
            margin-bottom: 32px;
        }
        .iframe-container2 {
            width: 320px;
            margin: 16px auto 0;
        }
        .iframe-container2 iframe {
            height: 132px;
        }
        .how-enprimeur-item {
            display: block;
            width: 100%;
        }
        .how-enprimeur-item1, .how-enprimeur-item2, .how-enprimeur-item3 {
            margin-bottom: 32px;
        }
        .how-enprimeur-wrapper {
            background: transparent;
        }
        .how-icon {
            margin-top: 32px;
        }
        .padding200 {
            padding: 0 16px;
        }
        .padding80 {
            padding-top: 32px;
            padding-bottom: 32px;
        }
    }
</style>

<style>
.page-lp-collections .not-logged-btn-wrapper {
    display: none;
}
.page-lp-collections .site-navigation-not-logged {
    position: absolute;
    right: 32px;
    top: 24px;
}
.page-lp-collections .site-navigation-not-logged li {
    display: none;
}
.page-lp-collections .site-navigation-not-logged li.lang-nav {
    display: block;
}
.theme--light.v-btn.v-btn--has-bg.login-submit span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
}
</style>
